var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedalogoWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43869 7.56136L8.57778 1.42227C9.08704 0.913015 9.9127 0.913016 10.422 1.42227L16.561 7.56136C17.0703 8.07062 17.0703 8.89628 16.561 9.40554L10.422 15.5446C9.9127 16.0539 9.08704 16.0539 8.57778 15.5446L2.43869 9.40554C1.92943 8.89628 1.92943 8.07062 2.43869 7.56136Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7793 11.289C17.0802 10.988 17.585 11.0517 17.7676 11.4361C18.3315 12.623 18.6484 13.95 18.6484 15.3514C18.6484 20.404 14.5524 24.4998 9.5 24.4999C4.44752 24.4999 0.351562 20.404 0.351562 15.3514C0.351588 13.9501 0.667905 12.6231 1.23152 11.4361C1.41409 11.0517 1.91881 10.988 2.21979 11.2889L9.03896 18.1072C9.29359 18.3618 9.7064 18.3618 9.96101 18.1072L16.7793 11.289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedalogoWhite);
export default __webpack_public_path__ + "static/media/feedalogoWhite.3e93e2a1a470da12269d819f68cbbf6d.svg";
export { ForwardRef as ReactComponent };